import React, { useRef, useState } from "react";
import { useEffect, Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";

const people = ["Employees", "Third Parties", "Administrators"];

export default function (props) {
  const [isOpen, setIsOpen] = useState(false);
  const [people, setPeople] = useState([]);
  const [selectedPersons, setSelectedPersons] = useState(
    props.value ? props.value : ["This sucks"]
  );
  const label = props.label;
  const impedimentId = props.impedimentId ? props.impedimentId : null;
  const defaultValue = props.defaultValue;
  const value = props.value;
  const fieldName = props.name;
  const fieldType = props.fieldType; //multiple or single

  const dropdown = useRef(null);
  // close if the esc key is pressed

  //check if people array contains strings or objects
  //if objects, get the name property

  useEffect(() => {
    console.log("ISOPEN CHANGED", isOpen);
  }, [isOpen]);

  useEffect(() => {
    let peopleArray = props.options;
    setPeople(peopleArray);
    console.log("peopleArray", peopleArray);
  }, [props.options]);

  useEffect(() => {
    // console.log("clickHandler dropdown", dropdown.current);

    const clickHandler = ({ target }) => {
      console.log({
        dropdownRef: dropdown,
        clickhandler: "clickhandler dropdown",
        editButton: dropdown.current,
        editButtonContainsTarget:
          dropdown.current && dropdown.current.contains(target),
        target: target,
        edit: props.edit,
      });
      if (!dropdown.current) return;
      if (!isOpen || dropdown.current.contains(target)) return;

      setIsOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  function isSelected(value) {
    if (fieldType && fieldType == "single") {
      return selectedPersons == value ? true : false;
    }
    return selectedPersons
      ? selectedPersons.find((el) => el === value)
        ? true
        : false
      : false;
  }

  useEffect(() => {
    setSelectedPersons(props.value);
  }, [value]);

  function handleSelect(val) {
    console.log("handleSelect", val);
    let value;
    let id;
    let area;
    let selected;
    console.log("handleSelect val", val);
    if (typeof val == "object") {
      id = val.id;
      value = val.name ? val.name : val.label;
      selected = val.name ? val.name : area;
    } else {
      value = val;
    }

    console.log("handleSelect Multi", value);

    if (fieldType && fieldType == "single") {
      setSelectedPersons(value);
      props.handleSelect(id, impedimentId, value, val);
      setIsOpen(false);
      return;
    } else {
      let name = fieldName;
      console.log("Selected value: ", name, value);
      if (!isSelected(value)) {
        const selectedPersonsUpdated = [
          ...selectedPersons,
          people.find((el) => el === value),
        ];
        setSelectedPersons(selectedPersonsUpdated);
      } else {
        handleDeselect(value);
      }
      props.handleSelect(selectedPersons, name);
    }
  }

  function handleDeselect(value) {
    const selectedPersonsUpdated = selectedPersons.filter((el) => el !== value);
    console.log("handeSelect deSelect", selectedPersonsUpdated);
    setSelectedPersons(selectedPersonsUpdated);
    setIsOpen(true);
  }
  // close on click outside

  return (
    // <div className="flex items-center justify-center">
    //   <div className="w-full max-w-xs mx-auto">
    <Listbox
      //   as="div"
      //   name={props.name}
      key={impedimentId}
      className="z-0 space-y-1"
      value={selectedPersons}
      // defaultValue={defaultValue}
      onChange={(value) => handleSelect(value)}
      open={isOpen}
    >
      {() => (
        <>
          {/* <Listbox.Label className=" mt-1 block text-sm leading-5 font-medium text-slate-700">
            {label}
          </Listbox.Label> */}
          <div id="dropdown" ref={dropdown} className="z-1000 relative mt-1">
            <span className="inline-block w-full rounded-md shadow-sm">
              {/* TO DO:  Remove border conditionally  */}
              <Listbox.Button
                id={"dropdown-button"}
                className={`z-0 cursor-default relative w-full 
                rounded-md border border-gray-300
                hover:shadow-[inset_0px_0px_2px_0px_rgba(0,0,0,0.3)] hover:shadow-brand-500 hover:border-brand-500
                bg-white pl-3 pr-10 py-2 text-left 
                cursor-pointer
                ${isOpen ? "border-brand-500  " : "border-gray-300"}
               transition ease-in-out duration-150 sm:text-sm sm:leading-5`}
                onClick={() => setIsOpen(!isOpen)}
                open={isOpen}
              >
                <span className="z-0 block ">
                  {((Array.isArray(selectedPersons) == false &&
                    selectedPersons == "") ||
                    selectedPersons == null) &&
                    `Select`}

                  {selectedPersons &&
                  Array.isArray(selectedPersons) &&
                  selectedPersons.length < 1
                    ? `Select`
                    : ` ${
                        selectedPersons && Array.isArray(selectedPersons)
                          ? selectedPersons.length + " Selected"
                          : selectedPersons
                      }`}
                </span>
                <span className="z-0 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                  {/* TO DO:  Change to down arrow */}
                  <svg
                    className="h-5 w-5 text-slate-400"
                    viewBox="0 0 20 20"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Listbox.Button>
            </span>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              className="z-40 w-96 max-h-60 overflow-auto absolute mt-1 rounded-md bg-white shadow-xl"
            >
              {/* <Transition
              unmount={false}
              show={isOpen}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-0"
              leaveTo="opacity-0"
              className="z-40 w-96 absolute mt-1 rounded-md bg-white shadow-xl"
            > */}
              <Listbox.Options
                static
                // onBlur={() => setIsOpen(false)}
                onMouseLeave={() => setIsOpen(false)}
                className={`cursor-pointer absolute right-0 mt-2 w-56 origin-top-right 
                divide-y divide-gray-100 rounded-md bg-white shadow-lg 
                ring-1 ring-black ring-opacity-5 focus:outline-none
              scrollbar-thin scrollbar-thumb-slate-300 
              scrollbar-track-slate-100  scrollbar-track-rounded-full 
              scrollbar-thumb-rounded-full  pr-4 pl-3 py-2

                `}
              >
                {typeof people[0] === "object"
                  ? people.map((person) => {
                      const selected = isSelected(
                        person.name ? person.name : person.value
                      );

                      return (
                        <Listbox.Option key={person.id} value={person}>
                          {({ active }) => (
                            <div
                              className={`${
                                active
                                  ? "text-white bg-brand-600"
                                  : "text-slate-900"
                              } cursor-pointer select-none relative rounded py-2 pl-8 pr-4
                              transition ease-in-out duration-100
                              `}
                            >
                              <span
                                className={`${
                                  selected ? "font-semibold" : "font-normal"
                                } block truncate`}
                              >
                                {person.area && person.area + " > "}
                                {person.name ? person.name : person.value}
                              </span>
                              {selected && (
                                <span
                                  className={`${
                                    active ? "text-white" : "text-primary-600"
                                  } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                >
                                  <svg
                                    className="w-3 h-3 shrink-0  ml-2"
                                    viewBox="0 0 12 12"
                                    fill="currentColor"
                                  >
                                    <path d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z" />
                                  </svg>
                                </span>
                              )}
                            </div>
                          )}
                        </Listbox.Option>
                      );
                    })
                  : people.map((person) => {
                      const selected = isSelected(person);
                      return (
                        <Listbox.Option key={person} value={person}>
                          {({ active }) => (
                            <div
                              className={`${
                                active
                                  ? "text-white bg-brand-600"
                                  : "text-slate-900"
                              } cursor-default select-none relative py-2 pl-8 pr-4`}
                            >
                              <span
                                className={`${
                                  selected ? "font-semibold" : "font-normal"
                                } block truncate`}
                              >
                                {person}
                              </span>
                              {selected && (
                                <span
                                  className={`${
                                    active ? "text-white" : "text-primary-600"
                                  } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                >
                                  <svg
                                    className="h-5 w-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </span>
                              )}
                            </div>
                          )}
                        </Listbox.Option>
                      );
                    })}
              </Listbox.Options>
            </Transition>
            {/* <div className="pt-1 text-sm">
              {selectedPersons &&
                selectedPersons.length > 0 &&
                Array.isArray(selectedPersons) && (
                  <>Selected: {selectedPersons.join(", ")}</>
                )}
            </div> */}
          </div>
        </>
      )}
    </Listbox>
    //   </div>
    // </div>
  );
}
